import Link from "next/link";
import FaImage from "../image/FaImage";
import Image from "next/image";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import { useSelector } from "react-redux";

export default function Footer() {
  const setting = useSelector((state) => state.setting.data);

  return (
    <footer className="footer-section">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-12 gap-6 md:gap-8">
          <div className="col-span-12 xl:col-span-5">
            {/* Logo */}
            <Link href="/" className="mb-4 md:mb-6 block">
              <FaImage
                src={
                 setting?.logo_dark_url ??
                  "/images/header-footer/main_logo_light.avif"
                }
                alt={"Mail Logo"}
                width={200}
                height={50}
                classes={"w-full"} 
                className="footer-logo"
              />
              {/* <FaImage
                src={
                 setting?.logo_dark_url ??
                  "/images/header-footer/main_logo_light.avif"
                }
                alt={"Mail Logo"}
                width={200}
                height={50}
                classes={"w-full hidden [.dark_&]:inline-block"} 
                className="footer-logo"
              /> */}
            </Link>
            <p className="footer-intro-text ">{setting?.slogan}</p>
            <div className="social-icons">
              {setting?.facebook && (
                <a
                  href={setting.facebook}
                  className="social-icon"
                  target="_blank"
                >
                  <span className="sr-only">Facebook</span>
                  <FaFacebookF />
                </a>
              )}
              {setting?.twitter && (
                <a
                  href={setting.twitter}
                  className="social-icon"
                  target="_blank"
                >
                  <span className="sr-only">Twitter</span>
                  <FaTwitter />
                </a>
              )}
              {setting?.instagram && (
                <a
                  href={setting.instagram}
                  className="social-icon"
                  target="_blank"
                >
                  <span className="sr-only">Instagram</span>
                  <FaInstagram />
                </a>
              )}
              {setting?.youtube && (
                <a
                  href={setting.youtube}
                  className="social-icon"
                  target="_blank"
                >
                  <span className="sr-only">YouTube</span>
                  <FaYoutube />
                </a>
              )}
            </div>
          </div>

          <div className="col-span-6 xl:col-span-2">
            <h4 className="widget-title ">গুরুত্তপূর্ণ লিংক</h4>
            <ul className="footer-links">
              {[
                { label: "ব্লগ", href: "/blogs" },
                { label: "নোটিশ বোর্ড", href: "/notice-board" },
                { label: "শিক্ষক লগইন", href: "/teacher/login" },
              ].map((link, index) => (
                <li key={index}>
                  <Link href={link.href} className="">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 xl:col-span-2">
            <h4 className="widget-title ">আমাদের সম্পর্কে</h4>
            <ul className="footer-links">
              {[
                { label: "আমরা কারা ", href: "/about-us" },
                { label: "যোগাযোগ করো", href: "/contact" },
              ].map((link, index) => (
                <li key={index}>
                  <Link href={link.href} className="">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-12 xl:col-span-3">
            <h4 className="widget-title ">যোগাযোগ</h4>
            {setting?.phone_1 && (
              <div className="footer-contact-item">
                <span className="title">ফোনঃ</span>
                <Link href={`tel:${setting.phone_1}`} className="value">
                  {setting.phone_1}
                </Link>
              </div>
            )}

            {setting?.email_1 && (
              <div className="footer-contact-item">
                <span className="title">ইমেইলঃ</span>
                <Link href={`mailto:${setting.email_1}`} className="value">
                  {setting.email_1}
                </Link>
              </div>
            )}
            <div className="footer-contact-item">
              <span className="title">লোকেশনঃ</span>
              <Link
                href="https://maps.app.goo.gl/7dKurqMv9fN1zuRd6"
                className="value"
              >
                {setting?.address}
              </Link>
            </div>
            <div className="button animated-btn-wrap inline-block mb-8">
              <Link href="/contact" className="footer-contact-btn animated-btn">
                যোগাযোগ করো{" "}
                <Image
                  src="/images/header-footer/arrow-right.avif"
                  width={12}
                  height={12}
                  className="ms-2 arrow-btn"
                  alt="Arrow Right"
                />
              </Link>
              <div className="animation-stroke">
                <div className="inner-stroke"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-copyright">
          <div className="flex flex-col md:flex-row sm:justify-between justify-start sm:items-center items-start gap-4">
            <div className="copyright-links">
              <Link href="/terms-conditions" className="links-item">
                ব্যবহারের শর্তাবলী
              </Link>
              <Link href="/privacy-policy" className="links-item">
                গোপনীয়তা নীতি
              </Link>
            </div>
            <p className="copyright-text">
              কপিরাইট &copy; {new Date().getFullYear()} ফোকাস একাডেমি। <span className='inline-block'>ডেভেলপড
              বাই{" "}
              <Link
                href="https://innovait.com.bd"
                target="_blank"
                className="text-primary-bg-2"
              >
                ইনোভা আইটি
              </Link></span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
